
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcNotificationButton as ObcNotificationButtonElement} from '@oicl/openbridge-webcomponents/dist/components/notification-button/notification-button.js';
 import {NotificationButtonClickEvent} from '@oicl/openbridge-webcomponents/dist/components/notification-button/notification-button.js';
 export type {NotificationButtonClickEvent} from '@oicl/openbridge-webcomponents/dist/components/notification-button/notification-button.js';
 

 
 export const ObcNotificationButton = createComponent({
   react: React,
   tagName: 'obc-notification-button',
   elementClass: ObcNotificationButtonElement,
   events: {
     
     onObcClick: 'obc-click' as EventName<CustomEvent<NotificationButtonClickEvent>>,
   }
  });
 
 